import { CancelToken } from 'axios';
import { http } from '../helpers/axiosHelper';
export default class ReferralService {
   async createReferral(body: Object) {
      return await http
         .post(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/referral', body)
         .then((response) => {
            if (response.status && response.data) {
               return response.data;
            } else {
               throw Error(`Kon referral niet aanmaken`);
            }
         })
         .catch((error) => {
            throw Error(`Kon referral niet aanmaken`);
         });
   }

   async getReferrals() {
      return await http.get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/referral  ').then((response) => {
         return response.data;
      });
   }

   async getExport(id: Number, startDate: any, endDate: any) {
      const url = `${
         import.meta.env.VITE_APP_API_BASE_URL_DATA
      }/dashboard/journey/${id}/influxPerReferral/download?start=${startDate}&end=${endDate}`;
      return await http.get(url);
   }

   async getAnswersPerReferralExport(id: Number, startDate: any, endDate: any) {
      const url = `${
         import.meta.env.VITE_APP_API_BASE_URL_DATA
      }/dashboard/journey/${id}/answers-per-referral/download?start=${startDate}&end=${endDate}`;
      return await http.get(url);
   }

   async getJourneyReferrals(journeyId: Number, cancelToken?: CancelToken) {
      return await http
         .get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/referral', {
            params: { 'filter[journey_ids]': journeyId, include: 'journey_team.team.tenant,visitorsCount,submissionsCount' },
            cancelToken: cancelToken,
         })
         .then((response) => {
            return response.data;
         });
   }

   async patch(id: Number, body: Object) {
      return await http
         .patch(import.meta.env.VITE_APP_API_BASE_URL_DATA + `/referral/` + id, body, { params: { include: 'team.tenant' } })
         .then((response) => {
            return response.data;
         });
   }
}
